import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from '../core/core.module';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from '../../app-routing.module';
import { CompetenciaDeslealComponent } from './sic/competencia-desleal/competencia-desleal.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UtilModule } from '../util/util.module';
import { ProteccionConsumidorComponent } from './sic/proteccion-al-consumidor/proteccion-consumidor/proteccion-consumidor.component';
import { DatosDemandanteComponent } from './sic/proteccion-al-consumidor/datos-demandante/datos-demandante.component';
import { DatosDemandadoComponent } from './sic/proteccion-al-consumidor/datos-demandado/datos-demandado.component';
import { ReclamoDirectoComponent } from './sic/proteccion-al-consumidor/reclamo-directo/reclamo-directo.component';
import { ProteccionQueRequiereComponent } from './sic/proteccion-al-consumidor/proteccion-que-requiere/proteccion-que-requiere.component';
import { PretensionesComponent } from './sic/proteccion-al-consumidor/pretensiones/pretensiones.component';
import { FundamentosDeDerechoComponent } from './sic/proteccion-al-consumidor/fundamentos-de-derecho/fundamentos-de-derecho.component';
import { PruebasComponent } from './sic/proteccion-al-consumidor/pruebas/pruebas.component';
import { NotificacionesComponent } from './sic/proteccion-al-consumidor/notificaciones/notificaciones.component';
import { TramitesRoutingModule } from './tramites-routing.module';
import { ObtentorVariedadVegetalComponent } from './ica/obtentor-variedad-vegetal/obtentor-variedad-vegetal.component';
import { SfcProConComponent } from './superfinanciera/sfc-procon/sfc-procon.component';
import { TablaDefinicionesComponent } from './supersalud/tabla-definiciones/tabla-definiciones.component';
import { SeleccionEntidadComponent } from './seleccion-entidad/seleccion-entidad.component';
import { CreacionDndaComponent } from './creacion-dnda/creacion-dnda.component';
import { CreacionDimarComponent } from './creacion-dimar/creacion-dimar.component';
import { PersonaComponent } from './persona/persona.component';
import { UppercaseDirective } from '../../directivas/uppercase.directive';
import { NgSelectModule } from '@ng-select/ng-select';
import { AuthModule } from '../auth/auth.module';
import { AsuntosMercantilesComponent } from './superintendecia-mercantiles/asuntos-mercantiles.component';
import { TranslatePipe } from '@ngx-translate/core';
import { SeliaModalComponent } from './selia-modal/selia-modal.component';
import { PersonaAbogadoComponent } from './persona-abogado/persona-abogado.component';
import { SupersociedadesRoiComponent } from './reorganizacion-ordinaria-insolvencia/supersociedades-roi/supersociedades-roi.component';
import { RoiSociedadComponent } from './reorganizacion-ordinaria-insolvencia/roi-sociedad/roi-sociedad.component';
import { RoiSucursalesComponent } from './reorganizacion-ordinaria-insolvencia/roi-sucursales/roi-sucursales.component';
import { RoiPersonaComercianteComponent } from './reorganizacion-ordinaria-insolvencia/roi-persona-comerciante/roi-persona-comerciante.component';
import { RoiPersonaNoComercianteComponent } from './reorganizacion-ordinaria-insolvencia/roi-persona-no-comerciante/roi-persona-no-comerciante.component';
import { LiqJudicialTipoSolicitanteComponent } from './supersociedades/liquidacion-judicial/liq-judicial-tipo-solicitante/liq-judicial-tipo-solicitante.component';
import { LiqJudicialSociedadComponent } from './supersociedades/liquidacion-judicial/liq-judicial-sociedad/liq-judicial-sociedad.component';
import { LiqJudicialPnComercianteComponent } from './supersociedades/liquidacion-judicial/liq-judicial-pn-comerciante/liq-judicial-pn-comerciante.component';
import { LiqJudicialPnNoComercianteComponent } from './supersociedades/liquidacion-judicial/liq-judicial-pn-no-comerciante/liq-judicial-pn-no-comerciante.component';
import { LiqJudicialSucursalExtranjeraComponent } from './supersociedades/liquidacion-judicial/liq-judicial-sucursal-extranjera/liq-judicial-sucursal-extranjera.component';
import { ValidacionJudicialSociedadComponent } from './supersociedades-validacion-judicial/validacion-judicial-sociedad/validacion-judicial-sociedad.component';
import { ValidacionJudicialSucursalesComponent } from './supersociedades-validacion-judicial/validacion-judicial-sucursales/validacion-judicial-sucursales.component';
import { ValidacionJudicialComponent } from './supersociedades-validacion-judicial/validacion-judicial/validacion-judicial.component';
import { SfcDemandanteComponent } from './superfinanciera/sfc-demandante/sfc-demandante.component';
import { SfcDemandadoComponent } from './superfinanciera/sfc-demandado/sfc-demandado.component';
import { SfcApoderadoComponent } from './superfinanciera/sfc-apoderado/sfc-apoderado.component';
import { SfcNotificacionesComponent } from './superfinanciera/sfc-notificaciones/sfc-notificaciones.component';
import { SfcReclamoComponent } from './superfinanciera/sfc-reclamo/sfc-reclamo.component';
import { SfcDetalleComponent } from './superfinanciera/sfc-detalle/sfc-detalle.component';
import { JustinoModule } from '../justino/justino.module';

@NgModule({
  declarations: [
    CompetenciaDeslealComponent,
    ObtentorVariedadVegetalComponent,
    SfcProConComponent,
    ProteccionConsumidorComponent,
    DatosDemandanteComponent,
    DatosDemandadoComponent,
    ReclamoDirectoComponent,
    ProteccionQueRequiereComponent,
    PretensionesComponent,
    FundamentosDeDerechoComponent,
    PruebasComponent,
    NotificacionesComponent,
    ObtentorVariedadVegetalComponent,
    TablaDefinicionesComponent,
    SeleccionEntidadComponent,
    CreacionDndaComponent,
    CreacionDimarComponent,
    PersonaComponent,
    UppercaseDirective,
    AsuntosMercantilesComponent,
    SeliaModalComponent,
    PersonaAbogadoComponent,
    SupersociedadesRoiComponent,
    RoiSociedadComponent,
    RoiSucursalesComponent,
    RoiPersonaComercianteComponent,
    RoiPersonaNoComercianteComponent,
    LiqJudicialTipoSolicitanteComponent,
    LiqJudicialSociedadComponent,
    LiqJudicialPnComercianteComponent,
    LiqJudicialPnNoComercianteComponent,
    LiqJudicialSucursalExtranjeraComponent,
    ValidacionJudicialSociedadComponent,
    ValidacionJudicialSucursalesComponent,
    ValidacionJudicialComponent,
    SfcDemandanteComponent,
    SfcDemandadoComponent,
    SfcApoderadoComponent,
    SfcReclamoComponent,
    SfcNotificacionesComponent,
    SfcDetalleComponent
  ],
  imports: [
    CommonModule,
    UtilModule,
    CoreModule,
    ReactiveFormsModule,
    RouterModule,
    FormsModule,
    AppRoutingModule,
    TramitesRoutingModule,
    NgSelectModule,
    AuthModule,
    TranslatePipe,
    JustinoModule
  ],
  exports: [PersonaComponent, TablaDefinicionesComponent],
})
export class TramitesModule { }
